import AddConnectionRequest from "./AddConnectionRequest"

export default  AddConnectionRequest;



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/AddConnectionRequest/index.js